<template>
  <div>
    <label class="form-label">Nacionalidade <span class="text-muted small">(opcional)</span></label>
    <SelectUbbi v-model="form.nationality" :options="countries" searchable :disabled="disabled" />
    <div v-if="error" class="mt-1 small text-danger" role="status">{{ error }}</div>
  </div>
</template>

<script>
import http from '../helpers/http';
import SelectUbbi from './SelectUbbi.vue';

export default {
  components: { SelectUbbi },
  props: { form: { type: Object, required: true }, disabled: Boolean },
  data: () => ({ countries: [], error: '' }),
  async mounted() {
    try {
      const { data } = await http.get('/identity-documents/options');
      this.countries = Object.entries(data.countries).map(([value, label]) => ({ value: Number(value), label }));
    } catch {
      this.error = 'Não foi possível carregar os países. Reabra o formulário para tentar novamente.';
    }
  },
};
</script>
